export const CHOICES_SET = 'character.CHOICES_SET';
export const CHOICES_SET_COMMIT = 'character.CHOICES_SET_COMMIT';
